import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";

interface StaticBarProps {
    topicCount: string;
    totalScore: string;
    teacherFinishMark: string;
    stuPaperScore: string;
    viewPaper: string;
    stuDoFlg: string;
}

export default function StaticBar({
    topicCount,
    totalScore,
    teacherFinishMark,
    stuPaperScore,
    viewPaper,
    stuDoFlg
}: StaticBarProps) {
    return (
        <div className={style.root}>
            共 {topicCount} 题， {totalScore} 分
            {teacherFinishMark === "1" && stuDoFlg === "1" && (
                <span className={style.score}>总得分：{stuPaperScore}</span>
            )}
            {teacherFinishMark === "0" && stuDoFlg === "1" && (
                <span className={style.idle}>总得分：老师尚未批改主观题</span>
            )}
            {stuDoFlg === "0" && viewPaper === "1" && (
                <span className={classNames(style.orange, style.idle)}>
                    活动已结束，您尚未参与
                </span>
            )}
        </div>
    );
}
